<template>
  <div>
    <el-card>
      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column type="index" label="序号" min-width="80"></el-table-column>
        <el-table-column label="名称" prop="name" min-width="250"></el-table-column>
        <el-table-column label="标题" prop="title" min-width="250"></el-table-column>
        <el-table-column label="条件" prop="condition" min-width="250"></el-table-column>
      </el-table>

    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.getRuleList()
  },
  methods: {
    async getRuleList() {
      this.$axios.post('/admin/Auth/getRules', {}).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    }
  }
}
</script>

<style lang="less">
</style>
